//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
    createPosition,
    getAll,
    getPositionCompanyList,
    createPositionCompany,
    deletePosition,
    deletePositionCompany
} from '../../../api/repairPosition';
import arrayToTree from 'array-to-tree';
import SelectCompanyModal from './select-company-modal';

export default {
    name: 'page-duty-view',
    components: { SelectCompanyModal },
    props: {
        projectId: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            saving: false,
            loading: false,
            createPositionModal: false,
            show: false,
            selectCompanyModal: false,
            createPositionDto: {},
            list: [],
            rules: {
                displayName: [{ required: true, type: 'string', message: '请输入名称', trigger: 'blur' }]
            },
            positionCompanies: [],
            columns: [
                {
                    type: 'index',
                    align: 'center',
                    maxWidth: 66
                },
                {
                    title: '公司名称',
                    key: 'companyName',
                    align: 'center'
                },
                // {
                //     title: '公司电话',
                //     key: 'phone',
                //     align: 'center'
                // },
                // {
                //     title: '公司地址',
                //     key: 'address',
                //     align: 'center'
                // },
                {
                    title: '操作',
                    slot: 'action',
                    align: 'center'
                }
            ],
            positionCompany: {},
        };
    },
    methods: {
        /*部位节点*/
        getList() {
            let page = {
                projectId: this.projectId
            };
            getAll(page).then(res => {
                let data = res.data.result;
                this.list = [];
                this.list = arrayToTree(data, {
                    parentProperty: 'parentId',
                    customID: 'id'
                });

            }).finally(() => {

            });
        },
        onSave() {
            const vm = this;
            this.createPositionDto.projectId = this.projectId;
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.saving = true;
                    createPosition(this.createPositionDto).then(res => {
                        this.$Notice.success({
                            duration: 3,
                            title: '保存成功'
                        });
                        vm.createPositionModal = false;
                        vm.getList();
                    }).finally(() => {
                        this.saving = false;
                    });
                }
            });
        },
        cancel() {
            this.createPositionModal = false;
        },

        createPosition(row) {
            this.createPositionDto = {};
            this.createPositionDto = JSON.parse(JSON.stringify(row));
            this.createPositionModal = true;
        },
        renderContent(h, { root, node, data }) {
            let actions = [];
            if (data.parentId === null || data.parentId === 0) {
                actions = [
                    h('Button', {
                        props: Object.assign({}, this.buttonProps, {
                            icon: 'ios-add',
                            size: 'small'
                        }),
                        style: {
                            marginRight: '8px'
                        },
                        on: {
                            click: () => {
                                this.append(data);
                            }
                        }
                    })
                ];
            }

            let delBtn = h('Button', {
                props: Object.assign({}, this.buttonProps, {
                    icon: 'ios-remove',
                    size: 'small'
                }),
                on: {
                    click: () => {
                        this.remove(root, node, data);
                    }
                }
            });
            actions.push(delBtn);

            return h('span', {
                    style: {
                        display: 'inline-block',
                        width: '222px'
                    }
                },
                [
                    h('span', [
                        h('Icon', {
                            props: {
                                // type: 'ios-paper-outline'
                            },
                            style: {
                                // marginRight: '8px'
                            }
                        }),
                        h('span', data.title)
                    ]),
                    h('span', {
                        style: {
                            display: 'inline-block',
                            float: 'right',
                            marginRight: '32px'

                        }
                    }, actions)
                ]);
        },
        append(data) {
            // const children = data.children || [];
            // children.push({
            //     title: 'appended node',
            //     expand: true
            // });
            // this.$set(data, 'children', children);
            this.createPositionDto = {};
            this.createPositionDto = { id: 0, parentId: data.id, parentName: data.displayName };
            this.createPositionModal = true;
        },
        remove(root, node, data) {
            // const parentKey = root.find(el => el === node).parent;
            // const parent = root.find(el => el.nodeKey === parentKey).node;
            // const index = parent.children.indexOf(data);
            // parent.children.splice(index, 1);
            this.$Modal.confirm({
                title: this.L('Tips'),
                content: '删除' + data.displayName + '?',
                okText: this.L('Yes'),
                cancelText: this.L('No'),
                onOk: () => {
                    this.delPosition(data.id);
                }
            });
        },

        delPosition(id) {
            const vm = this;
            deletePosition(id).then(res => {
                vm.$Notice.success({
                    duration: 3,
                    title: '删除成功'
                });
                vm.getList();
            });
        },

        selectedTree(node, data) {
            if (data.parentId > 0) {
                // console.log(data);
                this.getPositionCompanyList(data.id);
                this.positionCompany = {};
                this.positionCompany.positionId = data.id;
                this.show = true;
            } else {
                this.show = false;
                this.positionCompany = {};
            }
        },

        /*关联施工单位*/
        getPositionCompanyList(positionId) {
            this.loading = true;
            getPositionCompanyList(positionId).then(res => {
                this.positionCompanies = [];
                this.positionCompanies.push(...res.data.result);
            }).finally(() => {
                this.loading = false;
            });
        },

        handleSelectCompany(data) {
            this.positionCompany.companyId = data.id;
            this.createPositionCompany();
        },

        createPositionCompany() {
            createPositionCompany(this.positionCompany).then(res => {
                this.selectCompanyModal = false;
                this.getPositionCompanyList(this.positionCompany.positionId);
            }).finally(() => {

            });
        },

        handleDelete(row) {
            this.$Modal.confirm({
                title: this.L('Tips'),
                content: '确认删除?',
                okText: this.L('Yes'),
                cancelText: this.L('No'),
                onOk: () => {
                    this.delPositionCompany(row);
                }
            });
        },

        delPositionCompany(row) {
            deletePositionCompany(row.id).then(res => {
                this.getPositionCompanyList(row.positionId);
            });
        }
    },
    created() {
        this.getList();
    }
};
